export enum AttachmentType {
    Image = 'image',
    Video = 'video',
    Audio = 'audio'
  }